const MONDAY = 1;
const SATURDAY = 6;

export const getDaysToDay = (refDay, nextDay) => (nextDay - refDay + 7) % 7;

export const addDays = (refDate, days) => {
    const date = new Date(refDate);
    date.setDate(date.getDate() + days);
    return date;
};

export const getNextWeekSaturday = (refDate) =>
    addDays(refDate, (getDaysToDay(refDate.getDay(), MONDAY) || 7) + 5);

export const getTwoMonthsOutLastSaturday = (refDate) => {
    const date = new Date(refDate);
    date.setMonth(date.getMonth() + 3);
    date.setDate(0); // Last day of previous month
    date.setDate(date.getDate() - getDaysToDay(SATURDAY, date.getDay()));
    return date;
};